import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const BoxWrapperStyled = styled(Box)({
  cursor: 'default',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  padding: '16px',
  justifyContent: 'space-between',
});

export const ContentStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});
